import React, { useEffect, useState, useRef } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
const metrics = [{
  id: 1,
  value: 99,
  suffix: "%",
  label: "Clean Claim Rate",
  description: "Precision coding that minimizes denials and maximizes cash flow."
}, {
  id: 2,
  value: 250,
  suffix: "+",
  label: "Practices Optimized",
  description: "Delivering excellence across diverse medical specialties."
}, {
  id: 3,
  value: 30,
  suffix: "%",
  label: "Revenue Growth",
  description: "Significant financial improvement through RCM optimization."
}, {
  id: 4,
  value: 15,
  suffix: "+",
  label: "Years of Expertise",
  description: "A legacy of compliance and administrative efficiency."
}];
function AnimatedCounter({
  value,
  suffix = "",
  isVisible
}: {
  value: number;
  suffix?: string;
  isVisible: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const end = value;
    const duration = 2000;
    const incrementTime = Math.abs(Math.floor(duration / end));
    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);
    return () => clearInterval(timer);
  }, [value, isVisible]);
  return <span>
      {count}
      {suffix}
    </span>;
}
export default function MeasurableImpact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="22252" id="impact-by-the-numbers" ref={ref} className="dark bg-background py-24 relative overflow-hidden">
      <div className="container px-4 mx-auto">
        {}
        <Card className="relative overflow-hidden border-0 bg-card text-foreground shadow-[0_4px_20px_-5px_rgba(0,0,0,0.3)] ring-1 ring-border/50">
          {}
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" />
          
          <CardContent className="relative z-10 p-8 md:p-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
              {metrics.map((metric, i) => <div key={metric.id} data-index={i} className="group flex flex-col items-center text-center transition-transform duration-500 ease-out hover:scale-105 cursor-default">
                  {}
                  <div className="mb-4 text-5xl md:text-6xl font-bold text-primary tracking-tighter font-mono transition-all duration-500 group-hover:drop-shadow-[0_0_20px_rgba(56,189,248,0.4)]">
                    <AnimatedCounter value={metric.value} suffix={metric.suffix} isVisible={isVisible} />
                  </div>

                  {}
                  <h3 className="text-lg font-bold text-foreground mb-2 font-default">
                    {metric.label}
                  </h3>

                  {}
                  <p className="text-sm text-muted-foreground max-w-[200px] leading-relaxed font-sans">
                    {metric.description}
                  </p>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}